import { Component, OnInit, Input } from '@angular/core';
import { LangService } from '../../core/lang.service';

@Component({
  selector: 'tra',
  templateUrl: './tra.component.html',
  styleUrls: ['./tra.component.scss']
})
export class TraComponent implements OnInit {

  @Input() id: number;
  @Input() slug: string;

  val: string;

  constructor(
    private langService:LangService
  ) { }

  ngOnInit() {
    this.val = this.langService.tra(this.slug || this.id);
  }

}
